// =====================================================================================================================
// HOME VIEW
//
//  The portfolio landing page
//

import { GridContainer, Ui } from "@stratisopt/platform";
import { UiFactory } from "@stratisopt/platform";

export class HomeView extends GridContainer {

    // =================================================================================================================
    // CONSTRUCTORS
    //

    // Create and initialize a new instance
    public static create():HomeView {
        let ui = new HomeView();
        ui.init();
        return ui;
    }

    // Initialize this instance
    public init() {

        // Initialize the super
        super.init(this._json);
        UiFactory.addChildren(this, this._json);
    }


    // =================================================================================================================
    // VIEW
    //

    private _json = {
        name:'homeView', publicName:'Home', sizeX:'100%', sizeY:'100%', alignContentY:'MIN',
        backColor:'black', textcolor:Ui.theme.COLOR_FontNeutral,
        textSizePlatform:Ui.theme.SIZE_FontNeutral,
        children:[
         
            {type:'V_CONTAINER', sizeX:'100%', sizeY:'100%', children:[
                {sizeX:'1*', sizeY:'1*',
                    effect:'driftUpLeft birds',
                    backColor:' url("/assets/image/my-bob-ross-seascape.jpg")', backPos:'left top 30%', backFit:'cover'
                },
            ]},
            {type:'V_CONTAINER', sizeX:'100%', sizeY:'100%', children:[

                {sizeX:'1*', name:'forestGradient', sizeY:'1*',
                    animate:'mask 300ms easeOut',
                    effect:'driftDownRight embers',
                    mask: 'linear-gradient(to right, transparent 30%, black 70%)',
                    backColor:'url("/assets/image/my-bob-ross-dark-forrest.jpg")', backPos:'right top', backFit:'cover'
                },
            ]},
           
            {type:'V_CONTAINER', sizeX:'1*', sizeY:'1*',  alignContentX:'mid', pad:'10px', scrollShowY:'true', children:[
              
                {type:'Logo_View'},

                {type:'H_CONTAINER', sizeX:'1*', sizeY:'1*', sizeMinY:'content',  textColor:Ui.theme.COLOR_FontNeutral, children:[
                    {type:'V_CONTAINER', sizeX:'1*', sizeY:'1*', alignContentX:'mid', sizeMinY:'content', alignContentY:'mid', children:[
                        {type:'V_CONTAINER', sizeX:'1*', margin:Ui.theme.SPACING_Nest, sizeMaxX:'300px', pad:Ui.theme.SPACING_Emphasize, backColor:Ui.theme.COLOR_ProjectsWindow, 
                            onTouch:'App.Show projectsView',
                            cursor:'pointer', effect:'hover',
                            onTouchEnter:'Ui.set forestGradient, mask, linear-gradient(to right, transparent 50%, black 90%)',
                            onTouchLeave:'Ui.set forestGradient, mask, linear-gradient(to right, transparent 30%, black 70%)',
                            borderRadius:Ui.theme.BORDER_Rounded, children:[
                            {type:'text', sizeX:'1*', textSize:'100%', textFit:'cover', textPos:'center center', value:'Projects'}
                        ]}
                    ]},
                     {type:'V_CONTAINER', sizeX:'1*', sizeY:'1*',  alignContentX:'mid',sizeMinY:'content', alignContentY:'mid', children:[
                        {type:'V_CONTAINER', sizeX:'1*', margin:Ui.theme.SPACING_Nest, sizeMaxX:'300px', pad:Ui.theme.SPACING_Emphasize, backColor:Ui.theme.COLOR_ResumeWindow, 
                            cursor:'pointer', effect:'hover',
                            onTouch:'App.Show resumeView',
                            onTouchEnter:'Ui.set forestGradient, mask, linear-gradient(to right, transparent 10%, black 50%)',
                            onTouchLeave:'Ui.set forestGradient, mask, linear-gradient(to right, transparent 30%, black 70%)',
                            borderRadius:Ui.theme.BORDER_Rounded, children:[
                            {type:'text', sizeX:'1*', textSize:'100%', textFit:'cover', textPos:'center center', value:'Résumé'}
                        ]}
                    ]},
                ]},
                {type:'Logo_View', sizeY:'1*', sizeMaxY:'content', opacity:'0%'},
                
            ]},

           
            
        ]
    };

}
